import React from 'react';

export default props => (
  <svg width={18} height={18} {...props}>
    <g fill="#FFF">
      <path d="M9 6.38A2.63 2.63 0 0 0 6.37 9 2.63 2.63 0 0 0 9 11.63 2.63 2.63 0 0 0 11.63 9 2.63 2.63 0 0 0 9 6.37zm0 3.75a1.13 1.13 0 1 1 0-2.26 1.13 1.13 0 0 1 0 2.25z" />
      <path d="M17.25 8.25h-1.54a6.76 6.76 0 0 0-5.96-5.96V.75a.75.75 0 0 0-1.5 0v1.54a6.76 6.76 0 0 0-5.96 5.96H.75a.75.75 0 0 0 0 1.5h1.54a6.76 6.76 0 0 0 5.96 5.96v1.54a.75.75 0 0 0 1.5 0v-1.54a6.76 6.76 0 0 0 5.96-5.96h1.54a.75.75 0 0 0 0-1.5zm-8.25 6A5.26 5.26 0 0 1 3.75 9 5.26 5.26 0 0 1 9 3.75 5.26 5.26 0 0 1 14.25 9 5.26 5.26 0 0 1 9 14.25z" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/images/icons/IconLocate.jsx